import * as React from 'react';
import {StyleSheet, View, ViewStyle} from 'react-native';

import NewEffectUsageHistoryButton from './NewEffectUsageHistoryButton';

interface Props {
  onPress: () => void;
}

const BottomNewEffectUsageHistoryButton: React.FunctionComponent<
  Props
> = props => {
  const {onPress} = props;
  return (
    <View style={styles.container}>
      <NewEffectUsageHistoryButton onPress={onPress} />
    </View>
  );
};

export default React.memo(BottomNewEffectUsageHistoryButton);

const styles = StyleSheet.create({
  container: {
    left: 0,
    right: 0,
    position: 'absolute',
    bottom: 16,
    alignItems: 'center',
  } as ViewStyle,
});
